import { render, staticRenderFns } from "./LxMessagingSettings.vue?vue&type=template&id=0b68e0a3&scoped=true"
import script from "./LxMessagingSettings.vue?vue&type=script&lang=js"
export * from "./LxMessagingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b68e0a3",
  null
  
)

export default component.exports